import { render, staticRenderFns } from "./UnidataEditor.vue?vue&type=template&id=a2dc6574&"
import script from "./UnidataEditor.vue?vue&type=script&lang=js&"
export * from "./UnidataEditor.vue?vue&type=script&lang=js&"
import style0 from "./UnidataEditor.vue?vue&type=style&index=0&id=a2dc6574&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports